import { render, staticRenderFns } from "./ListLocalVotacionUsuario.vue?vue&type=template&id=56f69724&"
import script from "./ListLocalVotacionUsuario.vue?vue&type=script&lang=js&"
export * from "./ListLocalVotacionUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports